import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import styles from "./MainButton.module.scss";

type ButtonProps = {
  text: string | undefined;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  isLoading?: boolean;
  children?: React.ReactNode;
};

const MainButton: React.FC<ButtonProps> = ({
  text,
  onClick,
  className = "",
  type = "button",
  disabled = false,
  isLoading = false,
  children,
}) => {
  return (
    <button
      className={`${styles.main_button} ${className}`}
      onClick={onClick}
      type={type}
      disabled={disabled || isLoading}
    >
      {isLoading && (
        <LoadingOutlined
          style={{ fontSize: 24, color: "#fff", marginRight: "20px" }}
          spin
        />
      )}
      <span>{text}</span>
    </button>
  );
};

export default MainButton;
